import { Link2, Unplug } from 'lucide-react';

/**
 * Visual hint: plan nodes with `item_id` are represented in the item list;
 * nodes without still need a workspace item (“unplugged”).
 */
export function PlanNodeWorkspaceItemBadge({
  itemId,
  className = '',
}: {
  itemId?: string | null;
  /** Extra classes for the SVG icon element */
  className?: string;
}) {
  if (itemId) {
    return (
      <span
        className="inline-flex flex-shrink-0"
        title="Represented by a prioritization workspace item"
        aria-hidden
      >
        <Link2 className={`h-3 w-3 text-[var(--green)] dark:text-[var(--text-ter)] ${className}`} />
      </span>
    );
  }

  return (
    <span
      className="inline-flex flex-shrink-0"
      title="Not in the workspace item list — save as item from node detail to connect"
      aria-hidden
    >
      <Unplug className={`h-3 w-3 text-[var(--mustard)]/80 dark:text-[var(--mustard)]/80 ${className}`} />
    </span>
  );
}
